import React from "react";
import http from '../modules/api';

import DatePicker from "react-datepicker";
import { da, ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import Button from '../modules/common/Button';

import { PreviewRoot } from "./component/PreviewRoot";         
import PreviewTrigger from "./component/PreviewTrigger";
// import { Button } from "react-bootstrap";

/**
 * PostsTableManager (vFinal)
 * - instagram_automation_settings_14.html의 테이블 레이아웃/클래스명 기반
 * - DatePicker로 날짜 범위 필터(한국어)
 * - 검색/상태/유형/기간 필터 + 정렬 + 페이징 + 체크박스 선택/일괄 기능
 * - 외부 전역 JS/jQuery 불필요
 *
 * props:
 *  - posts?: PostRow[]
 *  - pageSizes?: number[]        (기본: [20, 50, 100])
 *  - onClickNewPost?(): void
 *  - onView?(row: PostRow): void
 *  - onEdit?(row: PostRow): void
 *  - onDelete?(row: PostRow): void
 *  - onBulkEdit?(ids: string[]): void
 *  - onBulkDelete?(ids: string[]): void
 *
 * PostRow:
 *  {
 *    id: string;
 *    caption: string;
 *    type: '자동' | '수동';
 *    status: '게시됨' | '예약됨' | '임시저장' | '실패';
 *    publishedDate?: string; // 'YYYY.MM.DD'
 *    publishedTime?: string; // 'HH:mm'
 *    reach?: number | null;
 *    reachDeltaPct?: number | null;
 *    likes?: number | null;
 *    comments?: number | null;
 *    saves?: number | null;
 *    thumbnail?: string;     // 이미지 URL
 *    carouselCount?: number; // 캐러셀의 추가 페이지 수 (ex: +3)
 *  }
 */

// 컴포넌트 바깥 또는 클래스 상단에 상수로
const STATUS_OPTIONS = [
  { text: "게시됨",   value: "PUBLISHED" },
  { text: "예약됨",   value: "SCHEDULED" },
  { text: "임시저장", value: "DRAFT" },
  { text: "실패",     value: "FAILED" },
];

const TYPE_OPTIONS = [
  { text: "자동",     value: "Y" },
  { text: "수동",     value: "N" },
];

export default class InstagramPostList extends React.Component {
  static defaultProps = { pageSizes: [{value: 20, text: "20개"}, {value: 50, text: "50개"}, {value: 100, text: "100개"}] };

  constructor(props) {
    super(props);
    // const sample = this.samplePosts();
    this.state = {
      // 데이터
      posts: Array.isArray(props.posts) && props.posts.length ? props.posts : [],
      // posts: sample,

      // 필터/검색
      q: "",
      status: "",
      // type: "",
      is_auto: "",
      startDate: null, // DatePicker는 Date 객체
      endDate: null,

      // 페이징/정렬/선택
      page: 1,
      pageSize: 20,
      sortKey: "publishedAt", // 'caption' | 'reach' | 'likes' | 'comments' | 'saves' | 'publishedAt'
      sortDir: "desc",        // 'asc' | 'desc'
      selected: new Set(),
    };
  }

  componentDidMount() {
    console.log("### InstagramPostList ###")
    this.fetchPostsFromApi();
  }

  /**
   * API 호출: Spring Boot Instagram Media List
   */
  fetchPostsFromApi = async () => {
    const { status, is_auto, q, startDate, endDate, page, pageSize, sortKey, sortDir } = this.state;
    const formatDate = (date) => {
      if (!date) return null;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    try {
      const resp = await http.get("/rest/shop/instagram/media/list", {
        params: {
          status : status === "DRAFT" ? "" : status === "SCHEDULED" ? "READY" : status, // 'DRAFT'는 is_draft로 처리
          is_auto: is_auto,
          post_type : status === "SCHEDULED" ? "SCHEDULED" : "",
          q,
          is_draft: status === "SCHEDULED" ? "N" : status === "DRAFT" ? "Y" : "",    // 필요시 state에서 가져오도록 수정 가능
          startDate: startDate ? formatDate(startDate) : null,
          endDate: endDate ? formatDate(endDate) : null,
          sortKey: sortKey === "publishedAt" ? "reg_date" : sortKey,
          sortDir: sortDir.toUpperCase(), // ASC / DESC
          start: (page - 1) * pageSize,
          rowCnt: pageSize,
        },
      });

      const { total, list } = resp.data;

      // 백엔드 → 프론트 데이터 매핑
      const posts = (list || []).map((m) => {
        const slides = (m.items || [])
          .slice()                       // 방어 복사
          .sort((a,b) => (a.item_index??0) - (b.item_index??0))
          .map(it => it.source_url)
          .filter(Boolean);

        const cover = m.cover_image || slides[0] || "";

        const base = m.published_time || m.scheduled_time;

        // 임시저장('Y')이면서 예약('SCHEDULED')이 아닌 경우를 체크
        const isDraftNotScheduled = m.is_draft === "Y" && m.post_type !== "SCHEDULED"; 

        return {
          id: String(m.instagram_media_seq),
          caption: m.caption,
          status:
            m.status === "PUBLISHED" ? "게시됨" :
            m.status === "FAILED" ? "실패" :
            m.is_draft === "Y" ? "임시저장" :
            m.post_type === "SCHEDULED" ? "예약됨" : m.status,
          publishedDate:  (base && !isDraftNotScheduled)
                          ? new Date(new Date(base).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(0, 10)
                              .replace(/-/g, ".")
                          : "",
          publishedTime:  (base && !isDraftNotScheduled)
                          ? new Date(new Date(base).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(11, 16)
                          : "",
          view_cnt: m.view_cnt ?? null,
          like_cnt: m.like_cnt ?? null,
          comment_cnt: m.comment_cnt ?? null,
          save_cnt: m.save_cnt ?? null,
          thumbnail: cover,              // ← 첫 장을 커버로
          carouselCount: slides.length > 1 ? (slides.length - 1) : null,
          slides,                        // ← 프리뷰용 배열 추가
          hashtags: m.hashtags,          // ← 해시태그 추가
          isAuto: m.is_auto,
          isAutoText: m.is_auto == "Y" ? "자동" : "수동",
          image_ratio: m.image_ratio || "1/1",
        };
      });


      this.setState({ posts, total });
    } catch (err) {
      console.error("게시물 목록 조회 실패", err);
    }
  };

  // 샘플 데이터 (주입 없을 때)
  samplePosts() {
    return [
      {
        id: "1",
        caption: "겨울 신상품 입고! 🎉",
        type: "자동",
        status: "게시됨",
        publishedDate: "2024.01.15",
        publishedTime: "14:00",
        reach: 1234,
        reachDeltaPct: 15.2,
        likes: 89,
        comments: 12,
        saves: 5,
        thumbnail: "", // 없으면 placeholder
      },
      {
        id: "2",
        caption: "오늘의 데일리룩 추천 👗",
        type: "자동",
        status: "게시됨",
        publishedDate: "2024.01.14",
        publishedTime: "18:30",
        reach: 2456,
        reachDeltaPct: 32.1,
        likes: 156,
        comments: 23,
        saves: 12,
        thumbnail: "",
        carouselCount: 3,
      },
      {
        id: "3",
        caption: "주말 특가! 전 상품 30% 할인 🛍️",
        type: "수동",
        status: "예약됨",
        publishedDate: "2024.01.20",
        publishedTime: "10:00",
        reach: null,
        reachDeltaPct: null,
        likes: null,
        comments: null,
        saves: null,
        thumbnail: "",
      },
      {
        id: "4",
        caption: "권한 문제로 발행 실패",
        type: "자동",
        status: "실패",
        publishedDate: "2024.01.13",
        publishedTime: "12:00",
        reach: null,
        reachDeltaPct: null,
        likes: 0,
        comments: 2,
        saves: 0,
        thumbnail: "",
      },
    ];
  }

  // 유틸
  fmtNumber(n) { return (n === null || n === undefined) ? "-" : n.toLocaleString(); }
  
  // 이벤트
  changeSort = (key) => {
    this.setState((prev) =>
      prev.sortKey === key
        ? { sortDir: prev.sortDir === "asc" ? "desc" : "asc" }
        : { sortKey: key, sortDir: "desc" }
    , this.fetchPostsFromApi);
  };
  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, page: 1 });
  };
  setQuickRange = (type) => {
    const today = new Date();
    if (type === "today") {
      this.setState({ startDate: today, endDate: today, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "week") {
      const day = today.getDay();                 // 0=일
      const diff = day === 0 ? 6 : day - 1;       // 월요일 시작
      const monday = new Date(today); monday.setDate(today.getDate() - diff);
      const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
      this.setState({ startDate: monday, endDate: sunday, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "month") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
     this.setState({ startDate: first, endDate: last, page: 1 }, this.fetchPostsFromApi);
    } else {
      // 전체(초기화)
      this.setState({ startDate: null, endDate: null, page: 1 }, this.fetchPostsFromApi);
    }

    this.setState({ dateType: type });
  };

  // 선택/일괄
  toggleSelectAll = (e, rowsOnPage) => {
    const checked = e.target.checked;
    this.setState((prev) => {
      const next = new Set(prev.selected);
      if (checked) rowsOnPage.forEach((r) => next.add(r.id));
      else rowsOnPage.forEach((r) => next.delete(r.id));
      return { selected: next };
    });
  };
  toggleSelectOne = (id) => {
    this.setState((prev) => {
      const next = new Set(prev.selected);
      next.has(id) ? next.delete(id) : next.add(id);
      return { selected: next };
    });
  };

  goPage = (p) => this.setState({ page: p }, this.fetchPostsFromApi);
  changePageSize = (e) => this.setState({ pageSize: Number(e.target.value), page: 1 }, this.fetchPostsFromApi);

  onView = (row) => this.props.onView && this.props.onView(row);
  onEdit = (row) => this.props.onEdit && this.props.onEdit(row);
  onDelete = (row) => this.props.onDelete && this.props.onDelete(row);
  onBulkEdit = () => this.props.onBulkEdit && this.props.onBulkEdit(Array.from(this.state.selected));
  onBulkDelete = () => this.props.onBulkDelete && this.props.onBulkDelete(Array.from(this.state.selected));

  renderSortHead(label, key, align = "left", width = "auto") {
    const { sortKey, sortDir } = this.state;
    const active = sortKey === key;
    const arrow = active ? (sortDir === "asc" ? "▲" : "▼") : "";
    return (
      <th onClick={() => this.changeSort(key)} style={{ width: width, cursor: "pointer", textAlign: align }} title="정렬">
        {label} {arrow}
      </th>
    );
  }

  // 클래스 컴포넌트 내부 메서드(기존 handleInput 사용과 호환)
  handleSelectBox = (name) => (text, value /*, id*/) => {
    // 기존 this.handleInput(e) 로직과 맞추기 위해 synthetic event 형태로 호출
    this.handleInput({ target: { name, value } });
  };


  render() {
    const { pageSizes } = this.props;
    const { q, status, type, startDate, endDate, page, pageSize, selected, dateType } = this.state;
    const rows = this.state.posts;                  // 서버가 준 현재 페이지
    const total = this.state.total ?? rows.length;  // 서버 total 사용
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const idsOnPage = rows.map((r) => r.id);
    const allChecked = idsOnPage.length > 0 && idsOnPage.every((id) => selected.has(id));

    return (
      <PreviewRoot>
      <div id='page-wrapper' className="container eventFormPromotion" style={{backgroundColor: '#fafaf', minHeight:"100%"}}>
        <div id="posts" className="instagram-post-list page-section active">
          {/* 헤더 */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <h1 style={{ fontSize: 24, fontWeight: 600 }}>게시물 목록</h1>
            {/* <button className="btn btn-primary" type="button" onClick={() => this.props.onClickNewPost && this.props.onClickNewPost()}>
              + 새 게시물
            </button> */}
            <Button
                type={"hover_mint"}
                width={"100px"}
                height={"38px"}
                fontSize={"1rem"}
                onClick={() => {window.location.href = "/shop/instagram/InstagramCreatePost";}}
            >
                ＋ 새 게시물
            </Button>
          </div>

          {/* 필터 섹션 */}
          <div className="filter-section">
            <div className="filter-row">
              {/* <input
                type="text"
                className="form-control"
                placeholder="🔍 게시물 검색..."
                name="q"
                value={q}
                onChange={this.handleInput}
                style={{ flex: 1, maxWidth: 300 }}
              /> */}

              {/* <select className="form-control" name="status" value={status} onChange={this.handleInput} style={{ width: 150 }}>
                <option>전체 상태</option>
                <option>게시됨</option>
                <option>예약됨</option>
                <option>임시저장</option>
                <option>실패</option>
              </select>

              <select className="form-control" name="type" value={type} onChange={this.handleInput} style={{ width: 150 }}>
                <option>전체 유형</option>
                <option>자동</option>
                <option>수동</option>
              </select> */}

              <div style={{ flex: 1 }}>
                <TextInput
                    type="text"
                    id="search_q"
                    placeholder="🔍 게시물 검색..."
                    value={q}
                    onChange={(e, value) => {
                      this.setState({ q: value });
                    }}
                    width="100%"
                    height="36px"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        this.setState({ page: 1 }, this.fetchPostsFromApi);
                      }
                    }}
                />
              </div>

              <SelectBoxV2
                id="statusSelect"
                className="form-control"
                pageWrapperName="common-page-wrapper"
                width="150px"
                height="36px"
                padding="6px 30px 6px 10px"
                list={STATUS_OPTIONS}
                optionTexttName="text"
                optionValuetName="value"
                selectedValue={this.state.status}      // 기존 state 그대로 사용
                placeHolder="전체 상태"
                onClickOption={this.handleSelectBox("status")}
                tabIndex={0}
              />

              <SelectBoxV2
                id="typeSelect"
                className="form-control"
                pageWrapperName="common-page-wrapper"
                width="150px"
                height="36px"
                padding="6px 30px 6px 10px"
                list={TYPE_OPTIONS}
                optionTexttName="text"
                optionValuetName="value"
                selectedValue={this.state.is_auto}        // 기존 state 그대로 사용
                placeHolder="전체 유형"
                onClickOption={this.handleSelectBox("is_auto")}
                tabIndex={0}
              />

              <div className="robomd_date_picker flexBox" style={{ gap: 15, alignItems: "center", flexWrap: "nowrap" }}>
                {/* DatePicker - 시작일 */}
                <div className="date_picker_wrapper">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => this.setState({ startDate: date, page: 1 })}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  maxDate={endDate || undefined}
                  dateFormat="yyyy.MM.dd"
                  locale={ko}
                  isClearable
                  placeholderText="시작일"
                  customInput={<input className="form-control" style={{ width: 150 }} />}
                />
                </div>

                <span style={{ color: "#8e8e8e" }}>~</span>

                <div className="date_picker_wrapper">
                {/* DatePicker - 종료일 */}
                <DatePicker
                  selected={endDate}
                  onChange={(date) => this.setState({ endDate: date, page: 1 })}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate || undefined}
                  dateFormat="yyyy.MM.dd"
                  locale={ko}
                  isClearable
                  placeholderText="종료일"
                  customInput={<input className="form-control" style={{ width: 150 }} />}
                />
                </div>
              </div>

              <button className="btn btn-secondary" type="button" onClick={() => this.setState({ page: 1 }, this.fetchPostsFromApi)}>
                필터 적용
              </button>
            </div>

            <div className="filter-row">
              <div className="quick-filters">
                <button className={"quick-filter-btn" + (!dateType || dateType === "all" ? " active" : "")} onClick={() => this.setQuickRange("all")}>전체</button>
                <button className={"quick-filter-btn" + (dateType === "today" ? " active" : "")} onClick={() => this.setQuickRange("today")}>오늘</button>
                <button className={"quick-filter-btn" + (dateType === "week" ? " active" : "")} onClick={() => this.setQuickRange("week")}>이번 주</button>
                <button className={"quick-filter-btn" + (dateType === "month" ? " active" : "")} onClick={() => this.setQuickRange("month")}>이번 달</button>
              </div>
              <span style={{ marginLeft: "auto", fontSize: 14, color: "#8e8e8e" }}>
                총 {this.fmtNumber(total)}개 게시물
              </span>
            </div>
          </div>

          {/* 데이터 테이블 */}
          <div className="data-table">
            <table>
              <thead>
                <tr>
                  {/* <th style={{ width: 40, textAlign: "center" }}>
                    <input type="checkbox" checked={allChecked} onChange={(e) => this.toggleSelectAll(e, rows)} />
                  </th> */}
                  <th style={{ width: 80, paddingLeft: 30 }}>이미지</th>
                  {this.renderSortHead("문구", "caption")}
                  <th style={{ width: 80, textAlign: "center" }}>유형</th>
                  <th style={{ width: 80, textAlign: "center" }}>상태</th>
                  {this.renderSortHead("게시일시", "published_time", "center", 160)}
                  {/* {this.renderSortHead("도달", "reach", "center")} */}
                  {this.renderSortHead("참여", "total_cnt", "center", 160)}
                  {/* <th style={{ width: 140, textAlign: "center" }}>관리</th> */}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={9} style={{ textAlign: "center", padding: 40, color: "#8e8e8e" }}>
                      조건에 맞는 게시물이 없습니다.
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => {
                    const checked = this.state.selected.has(row.id);
                    const reachDelta = row.reachDeltaPct;
                    const deltaStyle = { fontSize: 11, color: typeof reachDelta === "number" ? (reachDelta >= 0 ? "#00a826" : "#ed4956") : "#8e8e8e" };
                    const engagement = (row.like_cnt ?? 0) + (row.comment_cnt ?? 0) + (row.view_cnt ?? 0);

                    return (
                      <tr key={row.id} 
                        onClick={() => {
                          if (row.status == "임시저장") {
                            window.location.href = `/shop/instagram/InstagramCreatePost?media_id=${row.id}`;
                          } else if (row.status == "예약됨") {
                            if (row.publishedDate && row.publishedTime) {
                              const dateStr = row.publishedDate.replaceAll('.', '-');
                              // console.log(">>> publishedDate, publishedTime", dateStr, row.publishedTime);
                              // console.log(">>> new Date", new Date(`${dateStr}T${row.publishedTime}:00`), new Date());
                              // console.log(">>> 비교", new Date(`${dateStr}T${row.publishedTime}:00`) > new Date());
                              // console.log(">>> type of", typeof dateStr, typeof row.publishedTime);
                              if (new Date(`${dateStr}T${row.publishedTime}:00`) > new Date()) {
                                window.location.href = `/shop/instagram/InstagramCreatePost?media_id=${row.id}`;
                              }
                            }
                          }
                        }}
                        style={{ cursor: row.status == "임시저장" ? "pointer" : row.status === "예약됨" ? row.publishedDate && row.publishedTime ? new Date(`${row.publishedDate.replaceAll('.', '-')}T${row.publishedTime}:00`) > new Date() ? "pointer" : "default" : "pointer" : "default" }}>
                        {/* <td style={{ textAlign: "center" }}>
                          <input type="checkbox" checked={checked} onChange={() => this.toggleSelectOne(row.id)} />
                        </td> */}
                        <td style={{ paddingLeft: 30 }}>
                          <PreviewTrigger
                            align="right"
                            previewData={{
                              slides: row.slides, // 서버에서 온 items -> slides 매핑한 것
                              caption: row.caption,
                              hashtags: row.hashtags,
                              publishedAt: row.publishedDate && row.publishedTime ? `${row.publishedDate} ${row.publishedTime}` : null,
                              metrics: { likes: row.like_cnt, comments: row.comment_cnt, saves: row.view_cnt },
                              image_ratio: row.image_ratio,
                            }}
                          >
                            {row.thumbnail ? (
                              <img
                                src={row.thumbnail}
                                alt="thumbnail"
                                style={{ width: 50, height: (row.image_ratio ? (50 * (row.image_ratio.split("/")[1] / row.image_ratio.split("/")[0])) : 50), borderRadius: 4, objectFit: "cover", display: "block" }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: 50, height: (row.image_ratio ? (50 * (row.image_ratio.split("/")[1] / row.image_ratio.split("/")[0])) : 50), borderRadius: 4,
                                  background: "linear-gradient(135deg, #667eea, #764ba2)"
                                }}
                              />
                            )}
                          </PreviewTrigger>

                        </td>
                        <td>
                          <div style={{ fontWeight: 500, textAlign: "left" }}>{row.caption || "-"}</div>
                          {/* <div style={{ fontSize: 12, color: "#8e8e8e", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {(row.publishedDate && row.publishedTime) ? `${row.publishedDate} ${row.publishedTime}` : "게시일시 미정"}
                          </div> */}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <span className={"badge " + (row.isAuto === "Y" ? "badge-auto" : "badge-manual")}>{row.isAutoText || "-"}</span>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <span className={
                            "badge " + (
                              row.status === "게시됨" ? "badge-published" :
                              row.status === "예약됨" ? "badge-scheduled" :
                              row.status === "임시저장" ? "badge-draft" :
                              row.status === "실패" ? "badge-failed" : ""
                            )}>
                            {row.status || "-"}
                          </span>
                        </td>
                        <td style={{ textAlign: "center", fontSize: 13 }}>
                          {row.publishedDate || "-"}<br />
                          <span style={{ color: "#8e8e8e", fontSize: 11 }}>{row.publishedTime || ""}</span>
                        </td>
                        {/* <td style={{ textAlign: "center" }}>
                          <div style={{ fontWeight: 600 }}>{row.reach === null || row.reach === undefined ? "-" : this.fmtNumber(row.reach)}</div>
                          <div style={deltaStyle}>
                            {typeof reachDelta === "number" ? `${reachDelta >= 0 ? "+" : ""}${reachDelta}%` : "-"}
                          </div>
                        </td> */}
                        <td style={{ textAlign: "center" }}>
                          <div style={{ display: "flex", gap: 8, justifyContent: "center", fontSize: 12 }}>
                            <span>❤️ {this.fmtNumber(row.like_cnt)}</span>
                            <span>💬 {this.fmtNumber(row.comment_cnt)}</span>
                            <span>👁 {this.fmtNumber(row.view_cnt)}</span>
                          </div>
                          <div style={{ marginTop: 4, fontSize: 11, color: "#8e8e8e" }}>
                            합계 {this.fmtNumber((row.like_cnt + row.comment_cnt + row.view_cnt) || 0)}
                          </div>
                        </td>
                        {/* <td style={{ textAlign: "center" }}>
                          <div style={{ display: "flex", gap: 5, justifyContent: "center" }}>
                            <button className="btn-text" style={{ fontSize: 12 }} type="button" onClick={() => this.onView(row)}>보기</button>
                            <button className="btn-text" style={{ fontSize: 12 }} type="button" onClick={() => this.onEdit(row)}>수정</button>
                            <button className="btn-text" style={{ fontSize: 12, color: "#ed4956" }} type="button" onClick={() => this.onDelete(row)}>
                              {row.status === "예약됨" ? "취소" : "삭제"}
                            </button>
                          </div>
                        </td> */}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

            {/* 페이지네이션 */}
          <div className="pagination" style={{ position: "relative", overflow: "visible"}}>
            {/* <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <span style={{ fontSize: 14, color: "#8e8e8e" }}>선택된 항목: {this.state.selected.size}개</span>
              <button className="btn-text" style={{ fontSize: 12 }} type="button" onClick={this.onBulkEdit}>일괄 수정</button>
              <button className="btn-text" style={{ fontSize: 12, color: "#ed4956" }} type="button" onClick={this.onBulkDelete}>일괄 삭제</button>
            </div> */}

            <div className="pagination-controls">
              <button className="page-btn" disabled={page <= 1} onClick={() => this.goPage(page - 1)}>◀</button>
              {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
                const half = Math.floor(5 / 2);
                let start = Math.max(1, page - half);
                let end = Math.min(totalPages, start + 4);
                if (end - start < 4) start = Math.max(1, end - 4);
                const p = start + i;
                if (p > totalPages) return null;
                return (
                  <button key={p} className={"page-btn" + (p === page ? " active" : "")} onClick={() => this.goPage(p)}>
                    {p}
                  </button>
                );
              })}
              <button className="page-btn" disabled={page >= totalPages} onClick={() => this.goPage(page + 1)}>▶</button>
            </div>

            <div className={"pagination-cnt-controls"} style={{ display: "flex", gap: 10, alignItems: "center", position: "absolute", right: "20px" }}>
              <span style={{ fontSize: 14, color: "#8e8e8e" }}>페이지당</span>
              {/* <select
                className="form-control"
                value={this.state.pageSize}
                onChange={this.changePageSize}
                style={{ width: 120 }}
              >
                {pageSizes.map((sz) => (
                  <option key={sz} value={sz}>{sz}개</option>
                ))}
              </select> */}

              <SelectBoxV2
                id="pageSizeSelect"
                className="form-control"
                pageWrapperName="common-page-wrapper"
                width="120px"
                height="36px"
                padding="6px 30px 6px 10px"
                list={pageSizes}
                optionTexttName="text"          // 객체의 text 필드 사용
                optionValuetName="value"        // 객체의 value 필드 사용
                selectedValue={this.state.pageSize}
                placeHolder="페이지 크기"
                onClickOption={(text, value) => this.changePageSize({ target: { value } })}
                tabIndex={0}
              />

            </div>
          </div>
        </div>
      </div>
      </PreviewRoot>
    );
  }
}